import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 4;
const MaintenanceMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};

export default MaintenanceMain;
